import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import video from "@/modules/video/video";
import { CLASSES } from "@/scripts/helpers/constants";
import { showMore } from "@/scripts/helpers/library";
import modalShow from "@/modules/containers/modal/modal";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedSignatureDark";
import "slick-carousel/slick/slick";
import contactForm from "@/modules/blocks/contact-form/index";

const customSelect = () => {
  $("#employees").select2({
    selectOnClose: false,
    minimumResultsForSearch: Infinity
  });

  $(".select2").after($("select#employees"));

  const hideCustomSelectError = event => {
    const parsley = $(event.target).next(".parsley-errors-list");
    if (parsley.length) parsley.remove();
  };

  $("#employees").on("select2:open", function(event) {
    hideCustomSelectError(event);
  });
  $("#employees").on("select2:close", function(event) {
    hideCustomSelectError(event);
  });
};

const stopVideo = () => {
  const stopVideoHandler = () => {
    const videoIframe = $("#modal-video iframe");
    let videoURL = videoIframe.attr("src");
    videoURL = videoURL.replace("?autoplay=1", "");
    videoIframe.attr("src", "");
    videoIframe.attr("src", videoURL);
  };

  $(document).keydown(function(e) {
    if (e.keyCode == 27 && $("body").hasClass("scroll-locked")) {
      stopVideoHandler();
    }
  });

  $(".modal__container, .modal__close").on("touchstart click", function(e) {
    if (e.target == this) {
      stopVideoHandler();
    }
  });
};

function stickyTableHeader() {
  const targetWidth = $(".services-comparison-table__tbody").width();

  $(window).scroll(function() {
    const fromTop = window.pageYOffset;
    const tableHeader = $(".services-comparison-table__thead");
    const startPoint = $(".js-services-comparison-table");
    const offsetTop = startPoint.offset().top;
    const offsetBottom = startPoint.innerHeight();
    const stopPoint = offsetTop + offsetBottom;
    const tabletBreakpoint = 960;
    const windowWidth = $(window).width();
    var marginTop = 0;
    const headerSticky = $(".pinned-header");

    if (headerSticky && tabletBreakpoint < windowWidth) {
      marginTop = 78;
    } else if (headerSticky && tabletBreakpoint > windowWidth) {
      marginTop = 76;
    } else {
      marginTop = 0;
    }

    if (
      fromTop >= offsetTop - marginTop &&
      fromTop <= stopPoint - (marginTop + tableHeader.height())
    ) {
      tableHeader.addClass("is-sticky");
      startPoint.addClass("is-active");
    } else {
      tableHeader.removeClass("is-sticky");
      startPoint.removeClass("is-active");
    }

    const overflowBlock = $(".table-wrapper");
    let position = overflowBlock.scrollLeft();
    const servicesHeaderSticky = $(
      ".services-comparison-table__thead.is-sticky"
    );

    if (servicesHeaderSticky.length) {
      $(".services-comparison-table__thead .row").css(
        "left",
        "-" + position + "px"
      );
    }
  });

  $(".table-wrapper").scroll(function() {
    let position = $(this).scrollLeft();
    if ($(".services-comparison-table__thead.is-sticky").length) {
      $(".services-comparison-table__thead .row").css(
        "left",
        "-" + position + "px"
      );
    }
  });

  $(".services-comparison-table__thead").css("max-width", targetWidth);
}

const animateClass = ".js-ready-animate";
let animateWasPlayedFlag = false;

const dataAnimation = () => {
  let params = {
    container: document.getElementById("animatedSignature"),
    renderer: "svg",
    loop: false,
    autoplay: true,
    animationData: animationData
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const inView = function(element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const startAnimation = () => {
  const animate = document.querySelector(animateClass);

  if (animate !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag && inView($(animate))) {
        dataAnimation();
        animateWasPlayedFlag = true;
      }
    });
  }
};

const initTableShowMore = () => {
  showMore(
    ".js-services-comparison-table",
    ".page-section--competition .js-button-show-more",
    undefined,
    true
  );
};

const sliderReviews = () => {
  const phoneBreakpoint = 639;
  const slickReviews = $(".js-reviews-slider");
  const prevArrow = $(".customers-reviews-button--prev");
  const nextArrow = $(".customers-reviews-button--next");

  if ($(window).width() <= phoneBreakpoint) {
    slickReviews.on("init reInit afterChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      if (!slick.$dots) {
        return;
      }
      const counter = (currentSlide ? currentSlide : 0) + 1,
        sumCouner = slick.$dots[0].children.length;

      if (counter === 1) {
        prevArrow.addClass("is-disable");
        prevArrow.attr("tabindex", "-1");
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
      } else if (counter === sumCouner) {
        nextArrow.addClass("is-disable");
        nextArrow.attr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      } else {
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      }
    });

    slickReviews.slick({
      infinite: false,
      slidesToShow: 1,
      speed: 150,
      arrows: false,
      accessibility: true,
      ariaPolite: true,
      dsf: false,
      fade: true,
      adaptiveHeight: true,
      dots: true
    });

    nextArrow.click(function(e) {
      e.preventDefault();
      slickReviews.slick("slickNext");
    });
    prevArrow.click(function(e) {
      e.preventDefault();
      slickReviews.slick("slickPrev");
    });
  }
};

$(document).ready(function() {
  video();
  addedLazyLoadImages();
  initWowLibrary();
  modalShow();
  video();
  stopVideo();
  contactForm();
  stickyTableHeader();
  startAnimation();
  initTableShowMore();
  sliderReviews();

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });

  $(window).on("resize", function() {
    stickyTableHeader();
  });
});
